module.exports = __webpack_public_path__ + "img/21.505ea4ea.jpg";